import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function ProblemSection() {
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-96">
      <FadeIn data-id="element-97">
        <h3 className="text-sm font-sans font-bold tracking-widest text-terracotta uppercase mb-4 text-center" data-id="element-98">
          The Real Problem
        </h3>
        <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-8 text-center leading-tight" data-id="element-99">
          Most "bloat" isn't permanent fat—it's stagnant fermentation.
        </h2>

        <div className="space-y-6 text-lg text-charcoal-light font-sans leading-relaxed" data-id="element-100">
          <p data-id="element-101">
            It's trapped gas and inflammatory fluid sitting between your skin
            and your muscles.
          </p>
          <p data-id="element-102">
            When you're stressed or eat the wrong "healthy" foods, your
            digestive system stages a coup. It holds onto water as a defensive
            response, leaving you feeling "puffed out" and tight.
          </p>
          <p data-id="element-103">
            The longer that waste sits there, the harder and more visible the
            bloat becomes.
          </p>
        </div>
      </FadeIn>
    </section>;
}